import React, { useState } from "react";
import "./styles/DashboardMenu.css";
import {
  SubTabBox,
  TabBox,
  TabItemLable,
} from "./BasicComponents";

import { AiOutlineUser } from "react-icons/ai";
import { GoHome } from "react-icons/go";
import {
  HiOutlineReceiptRefund,
  HiOutlineDocumentMagnifyingGlass,
} from "react-icons/hi2";

import { BsPostcard } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import "../localisation/index"
import { useLocation } from "react-router";

const DashboardMenu = () => {
  const location = useLocation();
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState({});

  const [activeDropDown, setActiveDropDown] = useState({
    myplan: false,
    credits: false,
  });

  const handleTab = (event) => {
    const id = event.target.closest(".parent").id;
  };

  const handleDropDown = (event) => {
    // event.stopPropagation();
    const id = event.currentTarget.id;
    setActiveDropDown((prev) => ({ ...prev, [id]: !activeDropDown[id] }));
  };

  return (
    <div className="dashboard-menu">
      {/* PC view */}
      <nav className="dashboard__pc-menu">
        <ul className="dashboard__menu-items">
          <li id="home" className="parent" onClick={handleTab}>
            <TabBox to={"/home"} active={`${activeTab?.home}`}>
              <GoHome className="menu-icons" />
              {t("dashboardMenu.home")}
            </TabBox>
          </li>

          <li id="account" className="parent" onClick={handleTab}>
            <TabBox active={`${activeTab?.account}`} to={"/my-account"}>
              <AiOutlineUser className="menu-icons" />
              {t("dashboardMenu.account")}
            </TabBox>

            <ul>
              <li>
                <SubTabBox
                  id="myplan"
                  onClick={handleDropDown}
                  to={"/my-account"}
                  active={"/my-account" === location.pathname}
                >
                  <TabItemLable>{t("dashboardMenu.plan")}</TabItemLable>
                </SubTabBox>
              </li>
              <ul>
                <li>
                  <SubTabBox
                    to={"/my-invoices"}
                    active={"/my-invoices" === location.pathname}
                  >
                    <TabItemLable>{t("dashboardMenu.invoice")}</TabItemLable>
                  </SubTabBox>
                </li>
                <li>
                  <SubTabBox
                    to={"/current-usage"}
                    active={"/current-usage" === location.pathname}
                  >
                    <TabItemLable>{t("dashboardMenu.currentUsage")}</TabItemLable>
                  </SubTabBox>
                </li>
              </ul>
            </ul>
          </li>

          <li id="giftcard" className="parent" onClick={handleTab}>
            <TabBox active={`${activeTab?.giftcard}`} to={"create-giftcard"}>
              <BsPostcard className="menu-icons" style={{ width: "20px" }} />
              {t("giftCardTable.giftCard")}
            </TabBox>

            <ul>
              <li>
                <SubTabBox
                  to={"/create-giftcard"}
                  active={"/create-giftcard" === location.pathname}
                >
                  <TabItemLable>{t("dashboardMenu.publishGc")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/resend-gift-card"}
                  active={"/resend-gift-card" === location.pathname}
                >
                  {/* <PiKeyReturn className="menu-icons" /> */}
                  <TabItemLable>{t("dashboardMenu.giftcardOrders")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/create-physical-gift-card"}
                  active={location.pathname === "/create-physical-gift-card"}
                >
                  <TabItemLable>{t("dashboardMenu.publishPhysicalGc")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/physical-gift-card-orders"}
                  active={location.pathname === "/physical-gift-card-orders"}
                >
                  <TabItemLable>{t("dashboardMenu.physicalGiftcardOrders")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/my-gift-card"}
                  active={"/my-gift-card" === location.pathname}
                >
                  {/* <HiOutlineWallet className="menu-icons" /> */}
                  <TabItemLable>{t("dashboardMenu.giftcardSku")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/manage-templates"}
                  active={"/manage-templates" === location.pathname}
                >
                  <TabItemLable>{t("dashboardMenu.manageTemplates")}</TabItemLable>
                </SubTabBox>
              </li>
            </ul>
          </li>
          <li id="storecredit" className="parent" onClick={handleTab}>
            <TabBox active={`${activeTab?.storecredit}`} to={"/refunds"}>
              <HiOutlineReceiptRefund className="menu-icons" />
              {t("dashboardMenu.storeCredit")}
            </TabBox>
            <ul>
              <li>
                <SubTabBox
                  to={"/refunds"}
                  active={"/refunds" === location.pathname}
                >
                  {/* <HiOutlineReceiptRefund className="menu-icons" /> */}
                  <TabItemLable>{t("dashboardMenu.gcCreditRefunds")}</TabItemLable>
                </SubTabBox>
              </li>
            </ul>
          </li>

          <li id="storecredit" className="parent" onClick={handleTab}>
            <TabBox active={`${activeTab?.storecredit}`} to={"/refunds"}>
              <HiOutlineDocumentMagnifyingGlass className="menu-icons" />
              {t("commonTexts.support")}
            </TabBox>
            <ul>
              <li>
                <SubTabBox to={"/faqs"} active={"/faqs" === location.pathname}>
                  {/* <HiOutlineDocumentMagnifyingGlass className="menu-icons" /> */}
                  <TabItemLable>{t("commonTexts.faq")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/issues"}
                  active={"/issues" === location.pathname}
                >
                  {/* <AiOutlineQuestionCircle className="menu-icons" /> */}
                  <TabItemLable>{t("commonTexts.issues")}</TabItemLable>
                </SubTabBox>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      {/* -------------------------------- Tablet view ------------------------------------*/}
      <div className="dashboard__tab-menu">
        <ul className="dashboard__menu-items">
          <li id="home" className="parent" onClick={handleTab}>
            <TabBox to={"/home"} active={`${activeTab?.home}`}>
              <GoHome className="menu-icons" />
              {t("dashboardMenu.home")}
            </TabBox>
          </li>

          <li id="account" className="parent" onClick={handleTab}>
            <TabBox active={`${activeTab?.account}`} to={"/my-account"}>
              <AiOutlineUser className="menu-icons" />
              {t("dashboardMenu.account")}
            </TabBox>

            <ul>
              <li>
                <SubTabBox
                  id="myplan"
                  onClick={handleDropDown}
                  to={"/my-account"}
                  active={[
                    "/my-account",
                    "/my-invoices",
                    "/current-usage",
                  ].includes(location.pathname)}
                >
                  <TabItemLable>{t("dashboardMenu.plan")}</TabItemLable>
                </SubTabBox>
              </li>

              <ul>
                <li>
                  <SubTabBox
                    to={"/my-invoices"}
                    active={"/my-invoices" === location.pathname}
                  >
                    <TabItemLable>{t("dashboardMenu.invoice")}</TabItemLable>
                  </SubTabBox>
                </li>
                <li>
                  <SubTabBox
                    to={"/current-usage"}
                    active={"/current-usage" === location.pathname}
                  >
                    <TabItemLable>{t("dashboardMenu.currentUsage")}</TabItemLable>
                  </SubTabBox>
                </li>

              </ul>

              <li>
                <SubTabBox
                  to={"/kyc-status"}
                  active={"/kyc-status" === location.pathname}
                >
                  {/* <HiOutlineIdentification className="menu-icons" /> */}
                  <TabItemLable>{t("dashboardMenu.registration")}</TabItemLable>
                </SubTabBox>
              </li>
            </ul>
          </li>

          <li id="giftcard" className="parent" onClick={handleTab}>
            <TabBox active={`${activeTab?.giftcard}`} to={"create-giftcard"}>
              <BsPostcard className="menu-icons" style={{ width: "20px" }} />
              {t("giftCardTable.giftCard")}
            </TabBox>

            <ul>
              <li>
                <SubTabBox
                  to={"/create-physical-gift-card"}
                  active={location.pathname === "/create-physical-gift-card"}
                >
                  <TabItemLable>{t("dashboardMenu.publishPhysicalGc")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/physical-gift-card-orders"}
                  active={location.pathname === "/physical-gift-card-orders"}
                >
                  <TabItemLable>{t("dashboardMenu.physicalGiftcardOrders")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/create-giftcard"}
                  active={"/create-giftcard" === location.pathname}
                >
                  <TabItemLable>{t("dashboardMenu.publishGc")}</TabItemLable>
                </SubTabBox>
              </li>

              <li>
                <SubTabBox
                  to={"/my-gift-card"}
                  active={"/my-gift-card" === location.pathname}
                >
                  {/* <HiOutlineWallet className="menu-icons" /> */}
                  <TabItemLable>{t("dashboardMenu.giftcardSku")}</TabItemLable>
                </SubTabBox>
              </li>

              <li>
                <SubTabBox
                  to={"/resend-gift-card"}
                  active={"/resend-gift-card" === location.pathname}
                >
                  {/* <PiKeyReturn className="menu-icons" /> */}
                  <TabItemLable>{t("dashboardMenu.giftcardOrders")}</TabItemLable>
                </SubTabBox>
              </li>

              <li>
                <SubTabBox
                  to={"/manage-templates"}
                  active={"/manage-templates" === location.pathname}
                >
                  <TabItemLable>{t("dashboardMenu.manageTemplates")}</TabItemLable>
                </SubTabBox>
              </li>
            </ul>
          </li>
          <li id="storecredit" className="parent" onClick={handleTab}>
            <TabBox active={`${activeTab?.storecredit}`} to={"/refunds"}>
              <HiOutlineReceiptRefund className="menu-icons" />
              {t("dashboardMenu.storeCredit")}
            </TabBox>
            <ul>
              <li>
                <SubTabBox
                  to={"/refunds"}
                  active={"/refunds" === location.pathname}
                >
                  {/* <HiOutlineReceiptRefund className="menu-icons" /> */}
                  <TabItemLable>{t("dashboardMenu.gcCreditRefunds")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/configuration"}
                  active={"/configuration" === location.pathname}
                >
                  {/* <AiOutlineSetting className="menu-icons" /> */}
                  <TabItemLable>{t("dashboardMenu.preferences")}</TabItemLable>
                </SubTabBox>
              </li>
            </ul>
          </li>

          <li id="storecredit" className="parent" onClick={handleTab}>
            <TabBox active={`${activeTab?.storecredit}`} to={"/refunds"}>
              <HiOutlineDocumentMagnifyingGlass className="menu-icons" />
              {t("commonTexts.support")}
            </TabBox>
            <ul>
              <li>
                <SubTabBox to={"/faqs"} active={"/faqs" === location.pathname}>
                  {/* <HiOutlineDocumentMagnifyingGlass className="menu-icons" /> */}
                  <TabItemLable>{t("commonTexts.faq")}</TabItemLable>
                </SubTabBox>
              </li>
              <li>
                <SubTabBox
                  to={"/issues"}
                  active={"/issues" === location.pathname}
                >
                  {/* <AiOutlineQuestionCircle className="menu-icons" /> */}
                  <TabItemLable>{t("commonTexts.issues")}</TabItemLable>
                </SubTabBox>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DashboardMenu;
